/*
 * Action Types
 */
export enum DrawerTypes {
  SET_TOGGLE_DRAWER = '@drawer/SET_TOGGLE_DRAWER',
}

/*
 * State type
 */
export interface DrawerState {
  readonly open: boolean;
}
